import mergeConfig from 'coact/config/mergeConfig'
import salesOrdersConfig from './salesOrders/salesOrders.js'
import salesReqsConfig from './salesReqs/salesReqs.js'
import salesReqsMainView from './salesReqs/mainView/index.js'
import salesOrdersMainView from './salesOrders/mainView/index.js'
import recStatementsMainView from './recStatements/mainView/index.js'
import allModels from './index.js'

const models = {
  salesReqs: {
    views: {
      main: salesReqsMainView,
    },
  },
  salesOrders: {
    views: {
      main: salesOrdersMainView,
    },
  },
  recStatements: {
    views: {
      main: recStatementsMainView,
    },
  },
  salesOrderItems: {
    schema: {
      contents: {
        orderRef: salesOrdersConfig.schema,
      },
    },
  },
  salesReqItems: {
    schema: {
      contents: {
        orderRef: salesReqsConfig.schema,
      },
    },
  },
}

export default mergeConfig(allModels, models)
